var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',_vm._l((_vm.items),function(item,index){return _c('th',{key:index},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a20778","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductCategory/ProductCategoryTableHeader/ProductCategoryTableHeader.vue
// module id = null
// module chunks = 